// export function fuzzySearch(input: string, pattern: string) {
//   let inputIndex = 0;
//   let patternIndex = 0;

//   while (inputIndex < input.length && patternIndex < pattern.length) {
//     if (input[inputIndex] === pattern[patternIndex]) {
//       patternIndex++;
//     }
//     inputIndex++;
//   }

//   return patternIndex === pattern.length;
// }
// export function fuzzySearch(input: string, pattern: string) {
//   const regexPattern = pattern.split('').map(char => {
//     return char === ' ' ? '\\s*' : char;
//   }).join('.*');

//   const regex = new RegExp(regexPattern, 'i'); // 'i' để không phân biệt hoa thường

//   return regex.test(input);
// }
export function fuzzySearch(
  input: string,
  pattern: string,
  options: {
    caseSensitive?: boolean;
    allowSkip?: boolean;
    maxSkip?: number;
    useRegex?: boolean;
  } = {}
): boolean {
  const {
    caseSensitive = false,
    allowSkip = true,
    maxSkip = Infinity,
    useRegex = false,
  } = options;

  // Chuẩn bị input và pattern
  let processedInput = caseSensitive ? input : input.toLowerCase();
  let processedPattern = caseSensitive ? pattern : pattern.toLowerCase();
  processedPattern = processedPattern.trim();

  if (useRegex) {
    try {
      const regexPattern = processedPattern
        .split("")
        .map((char) => {
          if (char === " ") return "\\s*";
          return allowSkip ? `.*?${escapeRegExp(char)}` : escapeRegExp(char);
        })
        .join("");

      const regex = new RegExp(`^${regexPattern}`, caseSensitive ? "" : "i");
      return regex.test(processedInput);
    } catch (error) {
      console.error("Invalid regex pattern:", error);
      return false;
    }
  } else {
    let inputIndex = 0;
    let patternIndex = 0;
    let skippedChars = 0;

    while (
      inputIndex < processedInput.length &&
      patternIndex < processedPattern.length
    ) {
      if (processedInput[inputIndex] === processedPattern[patternIndex]) {
        patternIndex++;
        inputIndex++;
        skippedChars = 0;
      } else if (allowSkip && skippedChars < maxSkip) {
        skippedChars++;
        inputIndex++;
      } else {
        return false;
      }
    }

    return patternIndex === processedPattern.length;
  }
}

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}



/*
* TODO: Cách sử dụng 

Sử dụng mặc định (cho phép bỏ qua, không phân biệt hoa thường)
fuzzySearch("hello world", "he wor");  // true

Phân biệt chữ hoa/thường
fuzzySearch("Hello World", "hello", { caseSensitive: true });  // false

Không cho phép bỏ qua ký tự
fuzzySearch("hello", "hlo", { allowSkip: false });  // false

Giới hạn số ký tự bỏ qua
fuzzySearch("hello world", "hed", { maxSkip: 2 });  // false

Sử dụng regex
fuzzySearch("hello world", "h.*o w.*d", { useRegex: true });  // true
*/